<link rel="stylesheet" type="text/css"
    href="https://pixinvent.com/stack-responsive-bootstrap-4-admin-template/app-assets/fonts/simple-line-icons/style.min.css">
<link href="https://fonts.googleapis.com/css?family=Montserrat&display=swap" rel="stylesheet">
<div class="container-fluid">
    <div class="col-md-12" *ngIf="isLoading">
        <app-busy [message]="message"></app-busy>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="container-fluid">
                <div id="minimal-statistics">
                    <div class="row">
                        <div class="col-12 mt-3 mb-1">
                            <h4>Workflow Dashboard</h4>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-sm-3">
                                        <label>
                                            <b>Showing results for: </b>
                                        </label>
                                        <select class="form-control form-control-sm" (change)="filterChange($event)">
                                            <option value="Today" selected>Today</option>
                                            <option value="Yesterday">Yesterday</option>
                                            <option value="7days">Last 7 Days</option>
                                            <option value="Month">This Month</option>
                                        </select>
                                        </div>
                                    </div>
                            <div class="row">
                            <div class="col-3">
                                <div class="card" style="background-color: #F5F7FA;">
                                    <div class="card-content">
                                        <div class="card-body">
                                            <div class="media d-flex">
                                                <div class="align-self-center">
                                                    <i class="icon-speech font-large-2 float-left"
                                                        style="color:#274C9C !important"></i>
                                                </div>
                                                <div class="media-body text-right">
                                                    <h3 *ngIf="filterby=='Today'">{{card_data.NewApps}}</h3>
                                                    <h3 *ngIf="filterby=='Yesterday'">{{carddata_yesterday.NewAppsYesterday}}</h3>
                                                    <h3 *ngIf="filterby=='7days'">{{carddata_last7days.NewApps7Days}}</h3>
                                                    <h3 *ngIf="filterby=='Month'">{{carddata_thismonth.NewAppsThisMonth}}</h3>
                                                    <span>New Apps</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="card" style="background-color: #F5F7FA;">
                                    <div class="card-content">
                                        <div class="card-body">
                                            <div class="media d-flex">
                                                <div class="align-self-center">
                                                    <i class="icon-pencil font-large-2 float-left"
                                                        style="color:#274C9C !important"></i>
                                                </div>
                                                <div class="media-body text-right">
                                                    <h3 *ngIf="filterby=='Today'">{{card_data.Approvals}}</h3>
                                                    <h3 *ngIf="filterby=='Yesterday'">{{carddata_yesterday.ApprovalsYesterday}}</h3>
                                                    <h3 *ngIf="filterby=='7days'">{{carddata_last7days.Approvals7Days}}</h3>
                                                    <h3 *ngIf="filterby=='Month'">{{carddata_thismonth.ApprovalsThisMonth}}</h3>
                                                    <span>Approvals</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="card" style="background-color: #F5F7FA;">
                                    <div class="card-content">
                                        <div class="card-body">
                                            <div class="media d-flex">
                                                <div class="align-self-center">
                                                    <i class="icon-user font-large-2 float-left"
                                                        style="color:#274C9C !important"></i>
                                                </div>
                                                <div class="media-body text-right">
                                                    <h3 *ngIf="filterby=='Today'">{{card_data.Reassignment}}</h3>
                                                    <h3 *ngIf="filterby=='Yesterday'">{{carddata_yesterday.ReassignmentYesterday}}</h3>
                                                    <h3 *ngIf="filterby=='7days'">{{carddata_last7days.Reassignment7Days}}</h3>
                                                    <h3 *ngIf="filterby=='Month'">{{carddata_thismonth.ReassignmentThisMonth}}</h3>
                                                    <span>Reassignments</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-3">
                                <div class="card" style="background-color: #F5F7FA;">
                                    <div class="card-content">
                                        <div class="card-body">
                                            <div class="media d-flex">
                                                <div class="align-self-center">
                                                    <i class="icon-rocket font-large-2 float-left"
                                                        style="color:#274C9C !important"></i>
                                                </div>
                                                <div class="media-body text-right">
                                                    <h3 *ngIf="filterby=='Today'">{{card_data.Escalated}}</h3>
                                                    <h3 *ngIf="filterby=='Yesterday'">{{carddata_yesterday.EscalatedYesterday}}</h3>
                                                    <h3 *ngIf="filterby=='7days'">{{carddata_last7days.Escalated7Days}}</h3>
                                                    <h3 *ngIf="filterby=='Month'">{{carddata_thismonth.EscalatedThisMonth}}</h3>
                                                    <span>Escalations</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                                </div>
                        </div>
                        </div>                        
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <div class="card">
                        <div class="card-body">
                            <div class="chart-container">
                                <canvas id="piebyapp-chart" height="300">
                                </canvas>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-8">
                    <div class="card">
                        <div class="card-body">
                            <div class="chart-container">
                                <canvas id="barbystatus-chart" height="400">
                                </canvas>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="chart-container">
                                <canvas id="my-chart" height="300">
                                </canvas>
                            </div>
                        </div>
                    </div>
                </div>
            </div>           
           
            
        </div>
    </div>
    <div class="row">
        <button (click)="resetGridData()" class="btn_wrap" *ngIf="filtergrid">View All</button>
        <app-filter></app-filter>
        <fieldset class="card border-light shadow-sm" style="margin:0px;padding:0px;display: none;">
            <div class="row" style="margin:15px auto!important;padding-left:100px;">
                <div class="col-3" style="margin:0px!important;padding:0px!important;">
                    <input type="text" style="width:280px!important;height:35px"
                        class="form-control form-control-lg pull-right" [(ngModel)]="ApplicationNumber"
                        placeholder="Filter by app number..." title="Enter the app number to filter by...">
                </div>
                <div class="col-3">
                    <input type="text" style="width:210px!important;height:35px" class="form-control form-control-lg"
                        [(ngModel)]="ApplicationType" placeholder="Filter by app type..."
                        title="Enter the type to filter by...">
                </div>
                <div class="col-3">
                    <input type="text" style="width:210px!important;height:35px" class="form-control form-control-lg"
                        [(ngModel)]="Status" placeholder="Filter by status..." title="Enter the status to filter by...">
                </div>
                <div class="col-2 btn-show"
                    style="width:80px !important; margin:0px!important;padding-top:0px!important;">
                    <span (click)="onReset()" id="onResetAccount" title="Reset filters..."
                        class="btn btn-success btn-sm pull-right"><i class="fa fa-undo" aria-hidden="true"></i></span>
                    <span title="Apply filters..." id="onSearchAccount" (click)="onSearch()"
                        class="btn btn-primary btn-sm pull-right" style="margin-right: 6px !important;"><i
                            class="fa fa-filter" aria-hidden="true"></i></span>
                </div>
            </div>
        </fieldset>
<br>
        <div class="table-responsive">
            <table class="table table-sm custom_table">
                <thead class="thead-inverse">
                    <tr class="hd-clpse">
                        <th>Application Number</th>
                        <th>Carrier</th>
                        <th>Application Type</th>
                        <th>User Assigned</th>
                        <th>Status</th>
                        <th>Date Assigned</th>
                        <!-- <th class="text-center">View Activity</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr class="tbl-row" style="border-bottom: 1px solid #ddd;"
                        *ngFor="let item of activities | paginate: {itemsPerPage:pageSize, currentPage: utility.page ,totalItems: count};let index = index">
                        <td class="bfr-end-col">{{item.applicationId}}</td>
                        <td class="bfr-end-col">{{item.applicant}}</td>
                        <td class="bfr-end-col">{{item.applicationType}}</td>
                        <td class="bfr-end-col">{{item.userassignedname}}</td>
                        <td class="bfr-end-col">{{item.activityStatus}}</td>
                        <td class="bfr-end-col">{{item.dateassigned?.toLocaleString() | date:'dd/MM/yyyy'}}</td>
<!--                         <td class="bfr-end-col text-center">
                            <span>
                                <span title="Process activity" id="processAcc"
                                    class="action_btn"
                                    (click)="onView(item)">
                                    <img src="/assets/permit-viewer2.png" class="permit-view" />
                                </span>
                            </span>
                        </td> -->
                    </tr>
                </tbody>
                <tfoot>
                    <tr *ngIf="count > 10" class="pagination_row">
                        <td colspan="8">
                            <div class="row">
                                <div class="col-2">
                                    <div class="input-group mb-3 rm-brd"
                                        style="width:125px!important;height:30px!important;">
                                        <div class="input-group-prepend">
                                            <label class="input-group-text form-control-sm show-h"
                                                for="show-id">Show:</label>
                                        </div>
                                        <select class="form-control form-control-sm show-h" id="show-id"
                                            [(ngModel)]="pageSize" (change)="onChange()">
                                            <option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-10">
                                    <pagination-controls (pageChange)="utility.page = onNextOrPrevious($event)"
                                        style="margin-left:0px!important;float: right !important;"></pagination-controls>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="isEmpty">
                        <td colspan="4" class="rm-brd">
                            <span class="text-info text-small">No activity found.</span>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</div>

<!-- BEGIN POPUP-->

<button data-toggle="modal" data-target="#addEdit" id="secretButton" style="display:none"></button>

<div bsModal #childModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <label class="text-center title">Reassign Activity</label>
                <button type="button" class="close" (click)="onCancel()" data-dismiss="modal" id="closeButton"
                    #closebutton aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body modal-xl">
                <div id="stats-subtitle">
                    <div class="row">
                        <div class="col-xl-6 col-md-12">
                            <div class="card overflow-hidden" style="background-color: #F5F7FA;">
                                <div class="card-content">
                                    <div class="card-body cleartfix">
                                        <div class="media align-items-stretch">
                                            <div class="align-self-center">
                                            </div>
                                            <div class="media-body">
                                                <h5>Hours lapsed since assignment:</h5>
                                            </div>
                                            <div class="align-self-center">
                                                <h5><strong>{{user_data.TimeTaken | number:0}} hour(s)</strong></h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-6 col-md-12">
                            <div class="card" style="background-color: #F5F7FA;">
                                <div class="card-content">
                                    <div class="card-body cleartfix">
                                        <div class="media align-items-stretch">
                                            <div class="align-self-center">
                                            </div>
                                            <div class="media-body">
                                                <h5>Total activities for: <strong>{{assignedusername}}</strong></h5>

                                            </div>
                                            <div class="align-self-center">
                                                <h5><strong>{{user_data.CountAssigned}}</strong></h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div *ngIf="activity_status=='Awaiting Applicant Feedback'" class="col-sm-12">
                            <p style="color: red; text-align:center; padding: 5px;">This workflow activity is Awaiting Applicant Feedback and cannot be re-assigned</p>
                        </div>
                        <div class="col-sm-4">
                            <div class="col-sm-12">
                                <div>
                                    <label>
                                        <strong>Select User To Assign: </strong>
                                    </label>
                                    <select class="form-control form-control-sm" style="min-width: 100%"
                                        [(ngModel)]="selectedUser" [ngClass]="{'disabled':activity_status=='Awaiting Applicant Feedback'}" >
                                        <option [ngValue]="0">--- Please Select ---</option>
                                        <option *ngFor="let user of roleUsers" [ngValue]="user.userName">
                                            {{user.displayName}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-8">
                            <div class="col-sm-12" style="margin-top: 30px">
                                <button class="btn hd-btn-close" style="float: right"
                                    (click)="onCancel()">Cancel</button>
                                <button class="btn hd-btn" style="float: right" (click)="onProceed()"
                                    [disabled]="selectedUser == ''">Proceed</button>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="card" style="background-color: #F5F7FA;">
                        <div class="card-content">
                            <div class="card-body">
                    <div class="row" *ngIf="activities.length>0">
                            <div class="col-md-12" style="text-align: center;">
                              <h6>Application ID: {{application_id}} | Applicant Name: {{applicant_name}} | Application Type: {{application_type}}</h6>
                            </div>
                            <div class="col-md-12">
                           <div class="stepper_wrapper">
                               <div class="stepper_box">
                                 <div class="sticky">
                                   <div class="step_row" *ngFor="let activity of activities; let i = index; let last = last;">
                                     <div class="step step-two" id="other">
                                       {{activity.actiontaken}}
                                     </div>
                                     <div [class]="last ? 'circle last' : 'circle'"  [style.background-color]="activity.currentassignedyn ? background2 : background1">
                                       <img *ngIf="!activity.currentassignedyn"
                                         src="../../assets/stepper-img/done-56@2x.png"			  
                                         height="10"
                                       />
                                       <span style="color: transparent" *ngIf="!activity.currentassignedyn">2</span>
                                     </div>
                                     <div></div>
                                   </div>
                                 </div>
                               </div>
                             
                               <div class="stepper-content">
                                 <div style="margin-top:25px;">
                                 </div>  
                                 <div style="margin-top:25px;" *ngFor="let activity of activities">
                                   <div class="row">
                                       <div class="col-sm-3">
                                           <p><span style="font-weight: 600;">Date Assigned:</span> {{activity.dateassigned | date : "yyyy/MM/dd HH:mm"}}</p>
                                       </div>
                                       <div class="col-sm-3">
                                           <p *ngIf="!activity.currentassignedyn"><span style="font-weight: 600;">Date Completed: </span>{{activity.datecompleted | date : "yyyy/MM/dd HH:mm"}}</p>
                                           <p *ngIf="activity.currentassignedyn"><span style="font-weight: 600;">Date Completed: </span><span style="font-weight: 600; color:green;">Currently Assigned</span></p>
                                       </div>
                                       <div class="col-sm-6">
                                           <p><span style="font-weight: 600;">Status: </span>{{activity.status == 'Approval Recommended' ? 'In Progress' : activity.status}}</p>
                                       </div>
                                   </div>
                                   <br>
                                   <div class="row" >
                                       <div class="col-sm-12" *ngIf="activity.comment">
                                           <p *ngIf="!readmore"><span style="font-weight: 600;">Comment: </span>{{ (activity.comment.length>60) ? (activity.comment | slice:0:60)+'...':(activity.comment) }}
                                               <a *ngIf="activity.comment.length>60" (click)="onReadMore()" style="color:blue; cursor: pointer;"> read more</a>
                                           </p>
                                           <p [innerHTML]="activity.comment" *ngIf="readmore"></p>
                                           <a *ngIf="readmore" (click)="onReadMore()" style="color:blue; cursor: pointer;"> read less</a>
                                       </div>
                                   </div>
                                   <hr>
                                 </div>  
                               </div>
                             </div>
                            </div>
                    </div>
                    </div>
                    </div>
                    </div>
                    <p *ngIf="activities.length<=0">Application tracking details not found</p>
                </div>
            </div>
        </div>

    </div>
</div>

<!-- END POPUP-->